import React, { useState, useCallback } from 'react';

import './Input.scss';

import { Plate } from '../Plate/Plate';

export type InputType = 'text' | 'textarea' | 'email' | 'number' | 'password' | 'reset' | undefined;

export type HandleChangePropType = (inputValue: string) => void;
type HandleInputChangeType = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => void;

interface IInputProps {
  inputType: InputType;
  placeholder?: string;
  label?: string;
  isRequered?: boolean;
  maxLength?: number;
  value: string;
  setValue: any;
  isDisabled?: boolean;
}

export function Input({ inputType, placeholder, label, isRequered, maxLength, isDisabled, value, setValue }: IInputProps) {
  const finalInputType = inputType ? inputType : 'text';
  const finalPlaceholder = placeholder ? placeholder : '';
  const finalLabel = label || '';

  const [isInputFoused, setIsInputFoused] = useState(false);

  const setFormattedContent = useCallback(
    text => {
      setValue(text.slice(0, maxLength));
    },
    [maxLength, setValue]
  );
  const handleInputChange: HandleInputChangeType = (e) => {
    setFormattedContent(e.target.value);
  };

  const inputEvents = {
    onFocus: () => {
      setIsInputFoused(true);
    },
    onBlur: () => {
      setIsInputFoused(false);
    }
  }

  const create = {
    input: () => (
        <input
          onFocus={inputEvents.onFocus}
          onBlur={inputEvents.onBlur}
          type={finalInputType}
          placeholder={finalPlaceholder}
          name={finalPlaceholder}
          id={finalPlaceholder}
          onChange={handleInputChange}
          value={value}
          required={isRequered}
          disabled={isDisabled}
        />
    ),
    textarea: () => (
        <textarea
          onFocus={inputEvents.onFocus}
          onBlur={inputEvents.onBlur}
          rows={4}
          placeholder={finalPlaceholder}
          name={finalPlaceholder}
          id={finalPlaceholder}
          onChange={handleInputChange}
          value={value}
          required={isRequered}
          disabled={isDisabled}
        />
        
    )
  };

  const input = finalInputType === 'textarea'
    ? create.textarea()
    : create.input();

  return (
      <Plate plateType={isInputFoused ? 'accent' : 'neutral'} isElevated={!isInputFoused}>
        <div className="input-wrapper">
          { input }
          {
            maxLength
              ? (
                <p className={ 'input-symbols-counter' + (value.length >= maxLength ? ' input-symbols-counter--maxed' : '') }>
                  { value.length }/{ maxLength }
                </p>
              )
              : null
          }
          <label htmlFor={finalPlaceholder}>{finalLabel}</label>
        </div>
      </Plate>
  );
}
